import axios from 'axios';
import qs from 'qs'
import baseUrl from './env.js'

axios.defaults.withCredentials = true
// axios.defaults.timeout =  6000;

let service = function(url, data){
  let option = {
    method: 'POST',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: qs.stringify(data),
    url: baseUrl + url,
  }
  const token = sessionStorage.getItem('1to1token')
  if (token) {
  // 将获取到的token设置给header中的Authorization
    option.headers.Authorization = 'TOKEN ' + token
  }
  let langs = localStorage.getItem("lang")
  if(!langs){
    langs = "cn"
  }
  switch(langs){
    case 'cn':
      option.headers.Locale = 'zh_CN'; break
    case 'TW':
      option.headers.Locale = 'zh_HK'; break
    case 'en':
      option.headers.Locale = 'en_US'; break
  }
  return axios(option)
}

export default service;